import { render } from "./CrudContratoTransportador.vue?vue&type=template&id=ea0f7072"
import script from "./CrudContratoTransportador.vue?vue&type=script&lang=ts"
export * from "./CrudContratoTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script